module.exports = __webpack_public_path__ + "static/media/logo.935d8ee8.svg";